export default function isbase64(str) {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/isbase64.js